module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/161-ivory-coast-eda2355e4e374fddb903afc2cae49644.svg";